import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getStoreState, lockPolicy } from '@cogitate/ui-multi-utils';
import { storeKeys } from 'ui/data/constants/keys';

export const hasSubmittedPolicyId = (policy) => Boolean(policy?.id && String(policy.id).trim());

export const LockWhenPolicyIdReady = () => {
  const policy = useSelector((state) => state[storeKeys.PolicyReducer]);
  const lastLockedIdRef = useRef('');

  useEffect(() => {
    const currentPolicy = getStoreState(storeKeys.PolicyReducer);
    const policyId = hasSubmittedPolicyId(currentPolicy) ? String(currentPolicy.id).trim() : '';
    const quoteNumber = currentPolicy?.QuoteNumber;

    if (!policyId || !quoteNumber || String(quoteNumber).trim().length === 0) {
      if (!policyId) {
        lastLockedIdRef.current = '';
      }
      return;
    }

    if (lastLockedIdRef.current === policyId) {
      return;
    }

    lastLockedIdRef.current = policyId;
    lockPolicy(currentPolicy).catch(() => {
      lastLockedIdRef.current = '';
    });
  }, [policy?.id, policy?.QuoteNumber]);

  return null;
};
